import { z } from 'zod';
import { ProdutoLocalEstoqueStatus } from './enum';

export const ProdutoLocalEstoqueSchema = z.object({
    est_data_insercao: z.string(),
    est_descricao: z.string(),
    est_empresa_idpk: z.number().int(),
    est_idpk: z.number().int(),
    est_multiempresa_uuid: z.string(),
    est_padrao: z.enum(['S', 'N']),
    est_permite_movimentacao_manual: z.enum(['S', 'N']),
    est_permite_transferencia: z.enum(['S', 'N']),
    est_permite_venda: z.enum(['S', 'N']),
    est_produto_adicionar_automaticamente: z.enum(['S', 'N']),
    est_status: z.enum(ProdutoLocalEstoqueStatus),
    est_ultima_alteracao: z.string(),
    qtde_produtos: z.number().int(),
});

export type ProdutoLocalEstoque = z.infer<typeof ProdutoLocalEstoqueSchema>;

export type ProdutoLocalEstoqueBody = Pick<
    ProdutoLocalEstoque,
    | 'est_descricao'
    | 'est_padrao'
    | 'est_status'
    | 'est_permite_venda'
    | 'est_permite_movimentacao_manual'
    | 'est_permite_transferencia'
    | 'est_produto_adicionar_automaticamente'
>;

export const ProdutoLocalEstoqueResumoSchema = ProdutoLocalEstoqueSchema.pick({
    est_descricao: true,
});
